
export const getChunksFromString = (str: string, chunkSize: number) => {
    // when changing this (IDE warning) make sure it still works
    return str.match(new RegExp(`.{1,${chunkSize}}`, 'g'));
}